<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="icon" :label="$lang.icon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="chevron" :label="$lang.chevron" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
    </flex>
    <flex :spacing="3">
      <flex-col md24 :span="8" equal-height>
        <card :overflow-off="false" full-height>
          <card-text>
            <h-three :title="$lang.buttonOpener" />
            <menu-list
              opener="btn"
              :icon="icon ? 'account' : null"
              :header-text="$lang.menu"
              :bg-color="$root.colors.primary"
              :bg-color-lightness="$root.colors.bgColorLightness"
              :class="['block', 'w-full']"
              :disabled="disabled"
              :chevron="chevron">
              <template v-slot:list>
                <list>
                  <list-item @click="onMenuItemClick(item, 'menu-list:btn')" v-for="(item, index) in list" :key="index" :disabled="item.disabled">
                    <list-item-avatar v-if="item.avatar">
                      <avatar :text="item.avatar" :tile="false" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
                    </list-item-avatar>
                    <list-item-content v-if="item.title || item.subTitle">
                      <list-item-content-title v-if="item.title" v-html="item.title" />
                      <list-item-content-sub-title v-if="item.subTitle" v-html="item.subTitle" />
                    </list-item-content>
                    <list-item-icon v-if="item.icon">
                      <icon :name="item.icon" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" />
                    </list-item-icon>
                  </list-item>
                </list>
              </template>
            </menu-list>
          </card-text>
        </card>
      </flex-col>
      <flex-col md24 :span="8" equal-height>
        <card :overflow-off="false" full-height>
          <card-text>
            <h-three :title="$lang.splitButton" />
            <menu-list
              opener="split-btn"
              :icon="icon ? 'account' : null"
              :class="['block', 'w-full']"
              :bg-color="$root.colors.primary"
              :header-text="splitBtnHeaderText"
              :bg-color-lightness="$root.colors.bgColorLightness"
              :disabled="disabled">
              <template v-slot:list>
                <list>
                  <list-item :class="[splitBtnSelectedItemIndex ===  index ? 'bcq-list-item-selected' : null]" @click="onMenuItemClick(item, 'menu-list:split-btn', index)" v-for="(item, index) in list" :key="index" :disabled="item.disabled" :to="item.to">
                    <list-item-icon v-if="item.icon">
                      <icon :name="item.icon" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" />
                    </list-item-icon>
                    <list-item-content v-if="item.title || item.subTitle">
                      <list-item-content-title v-if="item.title" v-html="item.title" />
                      <list-item-content-sub-title v-if="item.subTitle" v-html="item.subTitle" />
                    </list-item-content>
                    <list-item-avatar v-if="item.avatar">
                      <avatar :text="item.avatar" :tile="false" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
                    </list-item-avatar>
                  </list-item>
                </list>
              </template>
            </menu-list>
          </card-text>
        </card>
      </flex-col>
      <flex-col md24 :span="8" equal-height>
        <card :overflow-off="false" full-height>
          <card-text>
            <h-three :title="$lang.openFromAvatar" />
            <menu-list
              opener="avatar"
              opener-width="64px"
              :avatar-src="`${$root.config.staticAssetsDir}/images/avatars/avatar-01.png`"
              :class="['block', 'w-full']"
              :disabled="disabled">
              <template v-slot:list>
                <list>
                  <list-item @click="onMenuItemClick(item, 'menu-list:avatar')" v-for="(item, index) in list" :key="index" :disabled="item.disabled" :to="item.to">
                    <list-item-avatar v-if="item.avatar">
                      <avatar :text="item.avatar" :tile="false" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
                    </list-item-avatar>
                    <list-item-content v-if="item.title || item.subTitle">
                      <list-item-content-title v-if="item.title" v-html="item.title" />
                      <list-item-content-sub-title v-if="item.subTitle" v-html="item.subTitle" />
                    </list-item-content>
                  </list-item>
                </list>
              </template>
            </menu-list>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageMenuList',
  mixins: [
    methods
  ],
  data () {
    return {
      list: [],
      icon: true,
      chevron: true,
      disabled: false,
      splitBtnHeaderText: this.$lang.menu,
      splitBtnSelectedItemIndex: null
    }
  },
  mounted () {
    this.getExternalData('menu-list.json', 'list')
  },
  methods: {
    onMenuItemClick (item, type, index) {
      if (type === 'menu-list:split-btn') {
        this.splitBtnHeaderText = item.title
        this.splitBtnSelectedItemIndex = index
      }
      this.log('click', type, item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/menu-list.vue